@if (customerBillingTransactionTypeWidgetData && initialized) {
    <mvs-widget [widgetData]="customerBillingTransactionTypeWidgetData"></mvs-widget>
}
